/*
Place this widget just before the closing tag of the .Article__Main element
*/

import Widget from "./base.js";
import { Component } from "preact";
import { getCookie, setCookie } from "tpm-utils";
import { MembershipDriveCount25Widget } from "./membership-drive-count-25.js";

export class MembershipDriveModal25Widget extends Widget {
	componentWillMount() {
		this.dismiss = this.dismiss.bind(this);
		this.toSm = this.toSm.bind(this);
		this.toMd = this.toMd.bind(this);
		this.state.size =
			getCookie("tpm_membership_drive_size") === "md" || this.props.fp
				? "md"
				: "lg";
		if (this.state.size === "lg") {
			document
				.querySelector(".Primary")
				.setAttribute("style", "padding: 0 !important");

			document
				.querySelector(".js_preheader-ad-container")
				.setAttribute("style", "display:none");
		}
	}

	dismiss() {
		this.setState({ dismiss: true }, () => {
			setCookie("tpm_membership_drive_size", "md", 0.5); // 12 hours
			document.querySelector(".Primary").removeAttribute("style");
			document
				.querySelector(".js_preheader-ad-container")
				.removeAttribute("style");
		});
	}

	toSm() {
		this.setState({ size: "sm" }, () => {});
	}

	toMd() {
		this.setState({ size: "md" }, () => {});
	}

	href(medium = "not_defined") {
		const source = "onsite";
		const campaign = "drive25";

		const id = "memberdrive";
		const promo = this.state.views > 9 ? "&promo=40offAny" : "";

		return `${document.location.origin}/memberships?utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}&utm_id=${id}${promo}`;
	}

	renderContent() {
		if (this.state.dismiss) return null;

		if (this.state.size === "sm") {
			return (
				<div
					className={`MembershipDriveModal25__Small --standalone ${
						this.props.fp ? "--fp" : ""
					}`}
				>
					<div
						className={`MembershipDriveModal25__SmallInner --invis  ${
							this.state.fade ? "--hide" : ""
						}`}
					>
						<a
							href={this.href("Seal")}
							class="MembershipDriveModal25__SmallSealContainer"
							id="drive25_Seal"
						>
							<img
								className="MembershipDriveModal25__SmallSeal --standalone"
								src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/seal.svg`}
								alt="TPM's Annual Membership Drive"
							/>
						</a>
					</div>
				</div>
			);
		}

		if (this.state.size === "md" || this.props.fp) {
			return (
				<div
					className={`MembershipDriveModal25__Small ${
						this.props.fp ? "--fp" : ""
					}`}
				>
					<div
						className={`MembershipDriveModal25__SmallInner  ${
							this.state.fade ? "--hide" : ""
						}`}
					>
						<div className="MembershipDriveModal25__SmallLeft">
							<div class="MembershipDriveModal25__SmallSealContainer">
								<img
									src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/seal.svg`}
									alt="TPM's Annual Membership Drive"
									className="MembershipDriveModal25__SmallSeal"
								/>
							</div>
							<div className="MembershipDriveModal25__SmallHeading">
								The&nbsp;Drive&nbsp;For&nbsp;2.5k{" "}
								<span className="linebreak">New&nbsp;Members</span>
							</div>
						</div>
						<div className="MembershipDriveModal25__SmallButton">
							<a
								href={this.href("Bumper")}
								className="js_membership-drive-button"
								id="drive25_Bumper"
							>
								25% Off All Memberships
							</a>
						</div>
						<div
							className="MembershipDriveModal25__SmallShrink"
							onClick={this.toSm}
						>
							<i className="fal fa-times"></i>
						</div>
					</div>
				</div>
			);
		}

		const urlParams = new URLSearchParams(window.location.search);
		const variant = urlParams.get("variant");
		if (variant === "a") return this.renderModalA();
		if (variant === "b") return this.renderModalB();

		if (Math.random() < 0.5) return this.renderModalA();
		else return this.renderModalB();
	}

	renderModalA() {
		return (
			<div className={`MembershipDriveModal25 --modal --red`}>
				<div className="MembershipDriveModal25__Top">
					<div
						onClick={this.dismiss}
						className="MembershipDriveModal25__Dismiss"
					>
						<i className="fal fa-times"></i>
					</div>
				</div>
				<div className={`MembershipDriveModal25__Inner`}>
					<div className="MembershipDriveModal25__Text">
						Celebrating 25 years of publishing for&nbsp;a&nbsp;reason.
					</div>
					<img
						className={`MembershipDriveModal25__Seal`}
						alt="TPM's Annual Membership Drive"
						src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/seal.svg`}
					/>
					<div className="MembershipDriveModal25__Heading">
						The Drive for 2.5k
						<div className="small">
							We hit our goal, but we’re not&nbsp;done&nbsp;yet!
						</div>
					</div>
					<div className="MembershipDriveModal25__Count">
						<MembershipDriveCount25Widget color="white" />
					</div>
					<div className="MembershipDriveModal25__Button">
						<a
							href={this.href("modalRed")}
							className="Button --white-red"
							id="drive25_modalRed"
						>
							25% Off All Memberships
						</a>
						<div className="MembershipDriveModal25__Text --regular">
							Discount available until March 31.
						</div>
					</div>
					<div className="MembershipDriveModal25__Text">
						Help us continue building a better kind of&nbsp;media&nbsp;company.
					</div>
				</div>
			</div>
		);
	}

	renderModalB() {
		return (
			<div className={`MembershipDriveModal25 --modal --images`}>
				<MembershipDriveGrid />
				<div className={`MembershipDriveModal25__Inner`}>
					<div className="MembershipDriveModal25__Top">
						<div
							onClick={this.dismiss}
							className="MembershipDriveModal25__Dismiss"
						>
							<i className="fal fa-times"></i>
						</div>
					</div>
					<div className="MembershipDriveModal25__Text">
						Celebrating 25 years of publishing for&nbsp;a&nbsp;reason.
					</div>
					<img
						className={`MembershipDriveModal25__Seal`}
						alt="TPM's Annual Membership Drive"
						src={`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/seal.svg`}
					/>
					<div className="MembershipDriveModal25__Heading">
						The Drive for 2.5k
						<div className="small">
							We hit our goal, but we’re not&nbsp;done&nbsp;yet!
						</div>
					</div>
					<div className="MembershipDriveModal25__Count">
						<MembershipDriveCount25Widget color="beige" />
					</div>
					<div className="MembershipDriveModal25__Button">
						<a
							href={this.href("modalTile")}
							className="Button --red"
							id="drive25_modalTile"
						>
							25% Off All Memberships
						</a>
						<div className="MembershipDriveModal25__Text --regular">
							Discount available until March 31.
						</div>
					</div>
					<div className="MembershipDriveModal25__Text">
						Help us continue building a better kind of&nbsp;media&nbsp;company.
					</div>
				</div>
			</div>
		);
	}
}

class MembershipDriveGrid extends Component {
	constructor(props) {
		super(props);
	}

	ratioCheck(a, b, goal, tolerance) {
		return Math.abs(a / h - goal) / goal <= tolerance;
	}

	resize() {
		const w = document.querySelector(".MembershipDriveModal25").offsetWidth;
		const h = document.querySelector(".MembershipDriveModal25").offsetHeight;

		const maxW = 409;
		const maxH = 363;
		const goalRatio = maxW / maxH;

		let perRow = 5;
		let perCol = 4;
		if (w < 996) {
			perRow = 4;
		}
		if (w < 768) {
			perRow = 3;
		}
		if (w < 556) {
			perRow = 2;
			perCol = 5;
		}

		//if the ratio is off add a row. only do this once, if it's still off, it's fine
		let acceptableRatio = this.ratioCheck(
			w / perRow,
			h / perCol,
			goalRatio,
			0.2
		);
		if (!acceptableRatio) {
			perRow += 1;
		}

		const width = Math.floor(w / perRow);
		const height = Math.floor(h / perCol);
		const ratio = w / h;
		this.setState({ perRow, perCol, width, height, goalRatio, ratio });
	}

	throttle(callbackFn, limit) {
		let wait = false;
		return function () {
			if (!wait) {
				callbackFn.call();
				wait = true;
				setTimeout(function () {
					wait = false;
				}, limit);
			}
		};
	}

	componentDidMount() {
		this.resize();

		window.addEventListener(
			"resize",
			this.throttle(this.resize.bind(this), 80).bind(this)
		);
	}

	images() {
		return [
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/1-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/2-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/3-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/4-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/5-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/6-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/7-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/8-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/9-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/10-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/11-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/12-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/13-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/14-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/15-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/16-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/17-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/18-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/19-25years-photogrid.jpg`,
			`https://${document.location.hostname}/wp-content/themes/tpm25/assets/images/membership-drive-25/20-25years-photogrid.jpg`,
		];
	}

	render() {
		if (this.state.width == null) return null;
		return (
			<div className="MembershipDriveGrid">
				{/* three times, some large layout require more than 20 images but nothing should require more than 60 */}
				{[...this.images(), ...this.images(), ...this.images()].map(
					(src, i) => (
						<div
							className="MembershipDriveGrid__Item"
							style={{
								backgroundImage: `url(${src})`,
								width: `${this.state.width}px`,
								height: `${this.state.height}px`,
							}}
							key={i}
						/>
					)
				)}
			</div>
		);
	}
}
